module.exports = __webpack_public_path__ + "img/hr-tree-02-d-leaves.101a9fd5.png";